// apps/web/src/lib/estoque/formatacao.ts — Fase 13, Plano 07 (EST-08, EST-10).
// Formatação pt-BR do estoque (funções puras): quantidade com unidade ao lado, custo unitário com 4 casas e valor com 2.
// Reaproveita os formatadores de Vendas para ter uma só regra de moeda e de casas decimais.
import { formatarMoeda, formatarQuantidade } from '../vendas/formatacao';

const TRACO = '—';

/**
 * Quantidade de estoque com a unidade ao lado (`19,6 kg`). Inteira para un/pç; até 4 casas sem zeros à direita para
 * kg/L/m². Quantidade ausente vira traço; unidade vazia não deixa espaço sobrando.
 */
export function formatarQuantidadeEstoque(valor: number | null | undefined, unidade: string): string {
  if (valor === null || valor === undefined) return TRACO;
  const numero = formatarQuantidade(valor, unidade);
  const sufixo = unidade.trim();
  return sufixo === '' ? numero : `${numero} ${sufixo}`;
}

/** Custo unitário/médio com 4 casas e a unidade (`R$ 4,7500/kg`). Sem custo é traço, nunca `R$ 0,0000`. */
export function formatarCustoUnitario(valor: number | null | undefined, unidade: string): string {
  if (valor === null || valor === undefined) return TRACO;
  const moeda = formatarMoeda(valor, 4);
  const sufixo = unidade.trim();
  return sufixo === '' ? moeda : `${moeda}/${sufixo}`;
}

/** Valor monetário com 2 casas (`R$ 1.234,56`); sem valor é traço. */
export function formatarValor(valor: number | null | undefined): string {
  if (valor === null || valor === undefined) return TRACO;
  return formatarMoeda(valor, 2);
}
